import React, {Component} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileText } from "@fortawesome/free-solid-svg-icons";

class AGBPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            props: props,
        }
    }
    render() {
        return (
            <div className="page overflow-hidden">
                <div className="header">
                    <div className="title text-center mt-4 mb-4">
                        <h2 style={{ color: '#021260', fontWeight: 'bold' }}>
                            <FontAwesomeIcon icon={faFileText} style={{ marginRight: '0.5rem' }} />
                            Allgemeine Geschäftsbedingungen (AGB)
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="container">
                        <div className="card" style={{
                            borderRadius: '1em',
                            boxShadow: 'rgba(0, 0, 0, 0.18) 0px 2px 4px',
                            padding: '2em',
                            marginBottom: '2em',
                            background: '#f5f5f5',
                            borderLeft: '5px solid #021260'
                        }}>
                            <div className="card-body">
                                <p className="mb-4 fs-5 fw-semibold" style={{ color: '#021260' }}>
                                    Mit der Nutzung dieses Portals erklären Sie sich mit den folgenden Bedingungen einverstanden:
                                </p>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>1. Verantwortung für Inhalte</h5>
                                    <p>
                                        Nutzer*innen sind selbst verantwortlich für alle Inhalte, die sie auf dem Portal hochladen, veröffentlichen oder teilen.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>2. Verbotene Inhalte</h5>
                                    <p>
                                        Es ist strikt untersagt, pornografische, gewaltverherrlichende, diskriminierende, rechtswidrige oder sonstige anstößige Inhalte hochzuladen oder zu verbreiten.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>3. Schadsoftware-Verbot</h5>
                                    <p>
                                        Alle hochgeladenen Dateien müssen virenfrei sein und dürfen keine schädliche Software (Malware, Trojaner etc.) enthalten.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>4. Keine Garantie auf Verfügbarkeit</h5>
                                    <p>
                                        Der Betreiber übernimmt keine Garantie für die ständige Erreichbarkeit oder fehlerfreie Funktion des Portals.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>5. Löschung von Inhalten und Accounts</h5>
                                    <p>
                                        Der Betreiber behält sich das Recht vor, Inhalte oder Nutzerkonten jederzeit ohne Angabe von Gründen zu löschen, insbesondere bei Verstößen gegen diese AGB.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>6. Speicherung von Daten</h5>
                                    <p>
                                        Es besteht kein Anspruch auf dauerhafte Speicherung oder Wiederherstellung von hochgeladenen Inhalten oder Profildaten.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>7. Datenschutz</h5>
                                    <p>
                                        Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung. Es werden nur die Daten erhoben, die zur Nutzung des Portals notwendig sind.
                                    </p>
                                    <p className="mt-2">
                                        <a
                                            href="/datenschutz"
                                            style={{
                                                color: '#01aef3',
                                                textDecoration: 'none',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Zur Datenschutzerklärung →
                                        </a>
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>8. Haftungsausschluss</h5>
                                    <p>
                                        Der Betreiber haftet nicht für Schäden, die durch die Nutzung des Portals oder durch Inhalte Dritter entstehen.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>9. Nutzung nur für legale Zwecke</h5>
                                    <p>
                                        Das Portal darf ausschließlich im Rahmen geltender Gesetze und Vorschriften genutzt werden.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 style={{ color: '#021260' }}>10. Änderung der AGB</h5>
                                    <p>
                                        Der Betreiber behält sich vor, diese AGB jederzeit zu ändern. Änderungen werden auf dem Portal bekannt gegeben. Die weitere Nutzung gilt als Zustimmung.
                                    </p>
                                </div>

                                {/*<div className="alert" style={{
                                    background: 'rgba(1, 174, 243, 0.1)',
                                    borderRadius: '0.5em',
                                    padding: '1em',
                                    borderLeft: '4px solid #01aef3'
                                }}>
                                    <p className="mb-0">
                                        <strong>Hinweis:</strong> Mit der Nutzung dieses Portals bestätigen Sie, dass Sie diese Allgemeinen Geschäftsbedingungen gelesen und verstanden haben und mit ihnen einverstanden sind.
                                    </p>
                                </div>*/}
                            </div>
                            <div className="text-center fst-italic fw-semibold" style={{ color: 'var(--bs-gray-700)' }} >
                                Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long' })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer mt-5">

                </div>
                <div className="disclaimer mt-5">
                    <span>my.ausbildung.cloud</span>
                </div>
            </div>
        )
    }
}


export default AGBPage;
